import type { PropsWithChildren, ReactElement } from "react";
import React from "react";

export const WhiteButton = ({
  className = "",
  onClick,
  children,
}: PropsWithChildren<{ className?: string; onClick: () => void }>): ReactElement => (
  <button
    type="button"
    className={`flex h-[38px] w-[38px] items-center justify-center rounded-full bg-white ${className}`}
    onClick={onClick}
  >
    {children}
  </button>
);
